import type { GetServerSidePropsContext } from 'next';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import PageCon from '@/components/AppLandingPage';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';

// @kunkun 该页面仅供公司app内嵌网页使用， 网页非投广告使用，也无网页页面入口
export default function Page({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const { t } = useLang('applandingpage');
    const router = useRouter();
    const { locale = 'us' } = router;

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['eu', 'uk', 'de', 'fr', 'it', 'es']} locale={locale} pathname={'app-landing-page'} />
            <PageLayout className={`${css.productcontent}  product_common product_common_real`}>
                <PageCon />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    const whiteLocaleList = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
